import React from 'react';
import { ForgotPasswordForm } from '@sprice237/react-auth-dom';
import Typography from '@mui/material/Typography';
import { AuthContentWrapper } from '$cmp/authContentWrapper';
import { AuthContentContainer } from '$cmp/authContentContainer';
import { FeatureFlags } from '$/featureFlags';

export const ForgotPasswordRoute: React.FunctionComponent = () => {
  return (
    <AuthContentWrapper>
      <AuthContentContainer>
        <div
          style={
            FeatureFlags.NewLogin ? { width: '400px' } : { width: '520px', paddingTop: '40px' }
          }
        >
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Reset Password
          </Typography>
          <Typography component="h2" variant="body1" align="center">
            Enter your email to reset your password
          </Typography>
          <ForgotPasswordForm loginRoutePath="/login" />
        </div>
      </AuthContentContainer>
    </AuthContentWrapper>
  );
};
